<template>
    <div class="container accountConfig" data-aos="fade-left" data-aos-duration="1500">
        <TitlePage title="Dados Bancários" subtitle="Configure os dados jurídicos e financeiros para receber os repasses de suas vendas" :hasMargin="true" />
        <div class="formPerson flex" v-if="typePerson == 1">
            <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CPF<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="comercialName"
                      placeholder="video.mp4"
                      disabled
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                  </div>
                </div>
          </div>
          <div class="col-form-inner col-8 col-md-8 col-lg-8">
            <div class="form-group">
              <div class="form-label">
                <label>Nome Completo<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="comercialName"
                  placeholder="video.mp4"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <small>Nome comercial de sua coleção, uso externo.</small>
              </div>
            </div>
      </div>

      <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Banco:</label>
          </div>
          <div class="form-input">
            <select
              required
              class="form-control"
              v-model="bank"
              disabled
            >
              <option value="" selected>001 - BANCO DO BRASIL S.A.</option>
            </select>
          </div>
        </div>
      </div>

          <div class="col-form-inner col-2 col-md-2 col-lg-2">
            <div class="form-group">
              <div class="form-label">
                <label>Agência<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="comercialName"
                  placeholder="00000"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
              </div>
            </div>
      </div>
      <div class="col-form-inner col-1 col-md-1 col-lg-1">
        <div class="form-group">
          <div class="form-label">
            <label>Dígito<v-tooltip text="Campo obrigatório" location="top">
              <template v-slot:activator="{ props }">
                <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
              </template>
            </v-tooltip></label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="comercialName"
              placeholder="00000"
              disabled
            />
            <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
            <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
          </div>
        </div>
  </div>
  <div class="col-form-inner col-2 col-md-2 col-lg-2">
    <div class="form-group">
      <div class="form-label">
        <label>Conta<v-tooltip text="Campo obrigatório" location="top">
          <template v-slot:activator="{ props }">
            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
          </template>
        </v-tooltip></label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="comercialName"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="col-form-inner col-1 col-md-1 col-lg-1">
    <div class="form-group">
      <div class="form-label">
        <label>Dígito<v-tooltip text="Campo obrigatório" location="top">
          <template v-slot:activator="{ props }">
            <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
          </template>
        </v-tooltip></label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="comercialName"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="actionsSave">
    <button class="btnSave">Salvar</button>
  </div>
        </div> 
        <div class="formPerson flex" v-if="typePerson == 2 && hasReady">
            <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CNPJ<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="CNPJ"
                      v-mask="'##.###.###/####-##'"
                      placeholder="##.###.###/####-##"
                      disabled
                    />
                    <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                    <small>Nome comercial de sua coleção, uso externo.</small>
                  </div>
                </div>
          </div>
          <div class="col-form-inner col-8 col-md-8 col-lg-8">
            <div class="form-group">
              <div class="form-label">
                <label>Razão Social<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="companyName"
                  placeholder="video.mp4"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <small>Nome comercial de sua coleção, uso externo.</small>
              </div>
            </div>
      </div>

      <div class="col-form-inner col-6 col-md-6 col-lg-6">
        <div class="form-group">
          <div class="form-label">
            <label>Banco:</label>
          </div>
          <div class="form-input">
            <select
              required
              class="form-control"
              v-model="bank"
              disabled
            >
            <option value="001">001 - BANCO DO BRASIL S.A.</option>
            <option value="033">033 - BANCO SANTANDER S.A.</option>
            <option value="104">104 - CAIXA ECONÔMICA FEDERAL</option>
            <option value="237">237 - BANCO BRADESCO S.A.</option>
            <option value="341">341 - BANCO ITAÚ S.A.</option>
            <option value="077">077 - BANCO INTER S.A.</option>
            <option value="260">260 - NUBANK</option>
            <option value="336">336 - BANCO C6 S.A.</option>
            <option value="290">290 - PAGSEGURO INTERNET S.A.</option>
            <option value="380">380 - PICPAY</option>
            </select>
          </div>
        </div>
      </div>

          <div class="col-form-inner col-2 col-md-2 col-lg-2">
            <div class="form-group">
              <div class="form-label">
                <label>Agência</label>
              </div>
              <div class="form-input">
                <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="agency"
                  placeholder="00000"
                  disabled
                />
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
                <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
              </div>
            </div>
      </div>
      <div class="col-form-inner col-1 col-md-1 col-lg-1">
        <div class="form-group">
          <div class="form-label">
            <label>Dígito</label>
          </div>
          <div class="form-input">
            <input
              type="text" 
              required
              class="form-control"
              v-model="agencyDigit"
              placeholder="00000"
              disabled
            />
            <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
            <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
          </div>
        </div>
  </div>
  <div class="col-form-inner col-2 col-md-2 col-lg-2">
    <div class="form-group">
      <div class="form-label">
        <label>Conta</label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="account"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<div class="col-form-inner col-1 col-md-1 col-lg-1">
    <div class="form-group">
      <div class="form-label">
        <label>Dígito</label>
      </div>
      <div class="form-input">
        <input
          type="text" 
          required
          class="form-control"
          v-model="accountDigit"
          placeholder="00000"
          disabled
        />
        <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
        <!-- <small>Nome comercial de sua coleção, uso externo.</small> -->
      </div>
    </div>
</div>
<!-- <div class="actionsSave">
    <button class="btnSave" @click="editCompany" disabled>Salvar</button>
  </div> -->
        </div> 
      </div>
      <Loader :hasReady="hasReady"/>
</template>

<script>
import ApiCompany from '@/utils/Weflix/company';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data() {
        return {
            typePerson: 2,
            CNPJ: '',
            companyName: '',
            bank: '',
            agency: '',
            agencyDigit: '',
            account: '',
            accountDigit: '',
            state: '',
            city: '',
            hasReady: false,
            idCompany: '',
            receivablesAdvance: false,
            mediaComments: false,
            cartClosure: false,
            showInstallmentValue: false,
           
        }
    },
    computed: {
        ...mapState(['token'])
    },
    components: {
        Loader,
        TitlePage
    },
    methods: {
        changeTypePerson(id) {
            this.typePerson = id;
        },
        async getCompany() {
          try {
            const response = await ApiCompany.getCompany(this.token);
            this.companyName = response.name;
            this.CNPJ = response.idFiscal;
            this.idCompany = response.id;
            this.bank = response.bank;
            this.agency = response.branch;
            this.account = response.account;
            this.accountDigit = response.digitAccount;
            this.agencyDigit = response.digitBranch;
            this.hasReady = true;

            this.receivablesAdvance = response.anticipation === 1 ? true : false;
            this.mediaComments = response.videoComments === 1 ? true : false;
            this.cartClosure = response.cartStatus === 1 ? true : false;
            this.showInstallmentValue = response.intallmentCheckout === 1 ? true : false;

          } catch (error) {
            console.error(error);
          }
        },
        async editCompany() {
          this.hasReady = false;
          const payload = {
            "idFiscal": this.CNPJ,
            "bank": this.bank,
            "branch": this.agency,
            "digitBranch": this.agencyDigit,
            "account": this.account,
            "digitAccount": this.accountDigit,
            "name": this.companyName,
             "anticipation": this.receivablesAdvance ? 1 : 0,
            "videoComments": this.mediaComments ? 1 : 0,
            "cartStatus": this.cartClosure ? 1 : 0,
            "intallmentCheckout": this.showInstallmentValue ? 1 : 0,
          }
          try {
            const response = await ApiCompany.editCompany(this.token, this.idCompany, payload);
            this.hasReady = true;
          } catch (error) {
            console.error(error);
          }
        }
    },
    created() {
        this.getCompany();
    }
}
</script>


<style scoped>
@import url('@/css/weflix/admin/account.css');
.container.accountConfig {
    width: 100%;
    max-width: 100%;
}
.itens-flex {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
}

.itens-flex > * {
    flex: 1 1 200px;
    /* Ajuste o valor mínimo conforme necessário */
    margin: 8px 0;
}
.container.accountConfig{
  height: 100%;
  min-height: 100%;
  padding: 20px;
}
.container.domainsConfig.weflix-admin-domain {
  padding: 20px;
}
@media (max-width: 768px) {
  .container.accountConfig {
    padding: 16px;
  }
  .accountConfig .formPerson.flex {
    padding: 0;
  }
}
</style>
